// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: common.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "familyos.v1";

/**
 * Family OS — shared envelope, pagination, and error types.
 *
 * Design notes:
 *   - Enum-valued fields (status, priority, role, etc.) are defined as
 *     `string` here, not proto enums, so existing lowercase wire values
 *     ("pending", "in_progress") keep working without touching DB queries
 *     or client checks. Graduating to real proto enums is a separate
 *     migration.
 *   - Timestamps use google.protobuf.Timestamp (RFC 3339 on the wire via
 *     protojson.UseProtoNames=true).
 *   - Opaque JSON blobs use google.protobuf.Struct.
 */

export interface PaginationRequest {
  page: number;
  limit: number;
  sort?: string | undefined;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total_count: string;
  has_next: boolean;
}

export interface ApiError {
  /** e.g. "INVALID_REQUEST", "NOT_FOUND" */
  code: string;
  /** user-facing message */
  message: string;
  details: { [key: string]: string };
}

export interface ApiError_DetailsEntry {
  key: string;
  value: string;
}

export interface ApiMeta {
  /** RFC 3339 UTC */
  timestamp: string;
  request_id?: string | undefined;
}

function createBasePaginationRequest(): PaginationRequest {
  return { page: 0, limit: 0, sort: undefined };
}

export const PaginationRequest: MessageFns<PaginationRequest> = {
  encode(message: PaginationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page !== 0) {
      writer.uint32(8).int32(message.page);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.sort !== undefined) {
      writer.uint32(26).string(message.sort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.page = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sort = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationRequest {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      sort: isSet(object.sort) ? globalThis.String(object.sort) : undefined,
    };
  },

  toJSON(message: PaginationRequest): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.sort !== undefined) {
      obj.sort = message.sort;
    }
    return obj;
  },

  create(base?: DeepPartial<PaginationRequest>): PaginationRequest {
    return PaginationRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PaginationRequest>): PaginationRequest {
    const message = createBasePaginationRequest();
    message.page = object.page ?? 0;
    message.limit = object.limit ?? 0;
    message.sort = object.sort ?? undefined;
    return message;
  },
};

function createBasePaginationMeta(): PaginationMeta {
  return { page: 0, limit: 0, total_count: "0", has_next: false };
}

export const PaginationMeta: MessageFns<PaginationMeta> = {
  encode(message: PaginationMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page !== 0) {
      writer.uint32(8).int32(message.page);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.total_count !== "0") {
      writer.uint32(24).int64(message.total_count);
    }
    if (message.has_next !== false) {
      writer.uint32(32).bool(message.has_next);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.page = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.total_count = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.has_next = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationMeta {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      total_count: isSet(object.total_count) ? globalThis.String(object.total_count) : "0",
      has_next: isSet(object.has_next) ? globalThis.Boolean(object.has_next) : false,
    };
  },

  toJSON(message: PaginationMeta): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.total_count !== "0") {
      obj.total_count = message.total_count;
    }
    if (message.has_next !== false) {
      obj.has_next = message.has_next;
    }
    return obj;
  },

  create(base?: DeepPartial<PaginationMeta>): PaginationMeta {
    return PaginationMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PaginationMeta>): PaginationMeta {
    const message = createBasePaginationMeta();
    message.page = object.page ?? 0;
    message.limit = object.limit ?? 0;
    message.total_count = object.total_count ?? "0";
    message.has_next = object.has_next ?? false;
    return message;
  },
};

function createBaseApiError(): ApiError {
  return { code: "", message: "", details: {} };
}

export const ApiError: MessageFns<ApiError> = {
  encode(message: ApiError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    Object.entries(message.details).forEach(([key, value]) => {
      ApiError_DetailsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = ApiError_DetailsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.details[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiError {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      details: isObject(object.details)
        ? Object.entries(object.details).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ApiError): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.details) {
      const entries = Object.entries(message.details);
      if (entries.length > 0) {
        obj.details = {};
        entries.forEach(([k, v]) => {
          obj.details[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<ApiError>): ApiError {
    return ApiError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiError>): ApiError {
    const message = createBaseApiError();
    message.code = object.code ?? "";
    message.message = object.message ?? "";
    message.details = Object.entries(object.details ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseApiError_DetailsEntry(): ApiError_DetailsEntry {
  return { key: "", value: "" };
}

export const ApiError_DetailsEntry: MessageFns<ApiError_DetailsEntry> = {
  encode(message: ApiError_DetailsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiError_DetailsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiError_DetailsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiError_DetailsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ApiError_DetailsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiError_DetailsEntry>): ApiError_DetailsEntry {
    return ApiError_DetailsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiError_DetailsEntry>): ApiError_DetailsEntry {
    const message = createBaseApiError_DetailsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseApiMeta(): ApiMeta {
  return { timestamp: "", request_id: undefined };
}

export const ApiMeta: MessageFns<ApiMeta> = {
  encode(message: ApiMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== "") {
      writer.uint32(10).string(message.timestamp);
    }
    if (message.request_id !== undefined) {
      writer.uint32(18).string(message.request_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timestamp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.request_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiMeta {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : "",
      request_id: isSet(object.request_id) ? globalThis.String(object.request_id) : undefined,
    };
  },

  toJSON(message: ApiMeta): unknown {
    const obj: any = {};
    if (message.timestamp !== "") {
      obj.timestamp = message.timestamp;
    }
    if (message.request_id !== undefined) {
      obj.request_id = message.request_id;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiMeta>): ApiMeta {
    return ApiMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiMeta>): ApiMeta {
    const message = createBaseApiMeta();
    message.timestamp = object.timestamp ?? "";
    message.request_id = object.request_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
